const SET_USER_PUBLIC_GALLERY_PROFILE_CONTENT = 'SET_USER_PUBLIC_GALLERY_PROFILE_CONTENT';

export { SET_USER_PUBLIC_GALLERY_PROFILE_CONTENT };
